import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
// Limitless imports
import { PortalButton } from "@limitless/portal";
import { limittessSmiley, limitlessSadSmiley } from "@limitless/images";
const useStyles = makeStyles(() => ({
  container: {
    marginTop: 40
  },
  content: {
    marginTop: 24
  },
  imageStyles: {
    marginTop: 40,
    marginBottom: 26
  }
}));
const QuizTryAgainSuccess = ({
  content,
  quizAttemptsLeft,
  buttonClick,
  t = v => v
}) => {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    justifyContent: "center",
    direction: "column",
    alignItems: "center",
    className: !buttonClick ? classes.container : ""
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    color: "textPrimary"
  }, content.header), content.sectionName === "success-message" ? /*#__PURE__*/React.createElement("img", {
    src: limittessSmiley,
    alt: "limitless-smiley",
    className: classes.imageStyles
  }) : content.sectionName === "no-attempts-left-message" && /*#__PURE__*/React.createElement("img", {
    src: limitlessSadSmiley,
    alt: "limitless-sad-smiley"
  }), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "column",
    style: {
      marginTop: 24
    },
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    color: "textPrimary",
    gutterBottom: true
  }, content.score), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    color: "textPrimary"
  }, content.scoreSuffix)), /*#__PURE__*/React.createElement(Typography, {
    variant: "subtitle1",
    color: "textPrimary",
    className: classes.content
  }, buttonClick ? t(content.subHeader.replace("<quizAttemptsLeft>", quizAttemptsLeft)) : t(content.subHeader.replace("<quizAttemptsLeft>", 2))), /*#__PURE__*/React.createElement(PortalButton, {
    className: classes.content,
    onClick: buttonClick ? () => buttonClick(content.sectionName) : null
  }, content.buttonLabel));
};
QuizTryAgainSuccess.propTypes = {
  content: PropTypes.object.isRequired,
  quizAttemptsLeft: PropTypes.number,
  buttonClick: PropTypes.func,
  t: PropTypes.func
};
export default QuizTryAgainSuccess;